import { Controller, useFormContext } from 'react-hook-form';
import { MentionsInput, Mention } from 'react-mentions';
import { Box, Typography, useTheme } from '@mui/material';

interface MentionDataItem {
  id: string | number;
  display?: string;
}

interface RHFMentionInputProps {
  name: string;
  disabled?: boolean;
  placeHolder?: string;
  mentionData: MentionDataItem[];
}

export function RHFMentionInput({
  name,
  disabled,
  mentionData,
  placeHolder,
}: RHFMentionInputProps) {
  const { control } = useFormContext();
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <MentionsInput
          {...field}
          placeholder={placeHolder}
          disabled={disabled}
          value={field.value}
          onChange={(e: any) => {
            field.onChange(e);
          }}
          style={{
            width: '100%',
            control: {
              fontSize: 14,
              borderRadius: 12,
              padding: '6px 10px',
              border: `1px solid ${theme.palette.grey[300]}`,
              minHeight: 36,
              lineHeight: '20px',
            },
            highlighter: {
              padding: '10px 12px',
              overflow: 'hidden',
            },
            input: {
              padding: '10px 12px',
              border: 'none',
              width: '100%',
              outline: 'none',
              top: 8,
            },
            suggestions: {
              position: 'absolute',
              zIndex: 9999,
              top: -5,
              left: 0,
              right: 0,
              transform: 'translateY(-100%)',
              maxHeight: 200,
              overflowY: 'auto',
              backgroundColor: 'white',
              border: `1px solid ${theme.palette.grey[300]}`,
              borderRadius: 8,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              list: {
                margin: 0,
                padding: 0,
                listStyle: 'none',
                backgroundColor: 'white',
              },
              item: {
                padding: '10px 12px',
                fontSize: 14,
                cursor: 'pointer',
                borderBottom: `1px solid ${theme.palette.grey[100]}`,
                backgroundColor: 'white',
                '&focused': {
                  backgroundColor: theme.palette.action.hover,
                },
              },
            },
          }}
        >
          <Mention
            trigger="@"
            data={mentionData}
            renderSuggestion={(suggestion: MentionDataItem) => (
              <Box sx={{ padding: '2px 8px' }}>
                <Typography variant="body2" sx={{ fontWeight: 300 }}>
                  {suggestion.display}
                </Typography>
              </Box>
            )}
          />
        </MentionsInput>
      )}
    />
  );
}
